module.exports = "/_next/static/images/pancake_lunch-d2aacec4fdd8398013aaf14a7c79fb1f.jpg";